import React, { useState, useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import '../styles/HptScreens.css';

const API_URL = process.env.REACT_APP_API_URL;

const DEPARTAMENTOS_861 = [
    { label: 'Operación', valor: 'OPERACION' },
    { label: 'Mantenimiento - Mecánico', valor: 'MECANICO' },
    { label: 'Mantenimiento - Eléctrico', valor: 'ELECTRICOS' },
    { label: 'Mantenimiento - Instrumentación', valor: 'INSTRUMENTACION' },
    { label: 'Mantenimiento - Campo Solar', valor: 'CAMPO SOLAR' },
    { label: 'Mantenimiento - Químico', valor: 'QUIMICO' },
    { label: 'PRL', valor: 'PRL' },
    { label: 'Genérico Planta', valor: 'GENERICO PLANTA' }
];

const DEPARTAMENTOS_579 = [
    { label: '00200', valor: 'PARQUE EÓLICO GECAMA' },
    { label: '00500', valor: 'PSFV LAS MOTILLAS' },
    { label: '00600', valor: 'PSFV LA REVUELTA' },
    { label: '00800', valor: 'PSFV ICTIO SOLAR' },
    { label: '00900', valor: 'PSFV ESTRELLA SOLAR' },
    { label: '01100', valor: 'PSFV ROCINANTE' },
    { label: '01200', valor: 'SOLARIA' },
    { label: '01201', valor: 'BELINCHÓN' },
    { label: '01203', valor: 'CASTOR' },
    { label: '01205', valor: 'AÑOVER' },
    { label: '01300', valor: 'SOLARIAA' },
    { label: '01400', valor: 'CLUSTER CALATRAVA' },
    { label: 'PRL', valor: 'PRL' },
    { label: 'Genérico Planta', valor: 'GENERICO PLANTA' }
];

const TIPOS_SOLICITUD = [
    { id: 'REPUESTOS', label: 'REPUESTOS (Requiere Nº de OT y Planta)' },
    { id: 'CONSUMIBLES', label: 'CONSUMIBLES (Petición agrupada taller - Stock < 20%)' },
    { id: 'HERRAMIENTAS', label: 'HERRAMIENTAS (Reposición semestral: Julio/Enero)' },
    { id: 'HERRAMIENTA_ESPECIFICA', label: 'HERRAMIENTA ESPECÍFICA (Urgente / Uso concreto)' },
    { id: 'MATERIAL_OFICINA', label: 'MATERIAL OFICINA Y SERVICIOS GRALES' },
    { id: 'REPOSICION_EPIS', label: 'REPOSICIÓN STOCKS EPIS' },
    { id: 'OTROS', label: 'OTROS (Especificar en justificación)' }
];

const EditCompraScreen = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [guardando, setGuardando] = useState(false);

    // Estados del formulario
    const [departamento, setDepartamento] = useState('');
    const [cp, setCp] = useState('861/862 TERMOSOLARES');
    const [idSolicitante, setIdSolicitante] = useState(null);
    const [nombreSolicitanteLabel, setNombreSolicitanteLabel] = useState('');
    const [tipoSolicitud, setTipoSolicitud] = useState('REPUESTOS');
    const [justificacion, setJustificacion] = useState('');
    const [materiales, setMateriales] = useState([]);

    // Archivos adjuntos
    const [archivosSubidos, setArchivosSubidos] = useState([]);
    const [archivosNuevos, setArchivosNuevos] = useState([]);

    const token = localStorage.getItem('userToken');
    let currentUser = {};
    if (token) {
        try {
            currentUser = JSON.parse(atob(token.split('.')[1]));
        } catch (e) {
            console.error("Error al decodificar token");
        }
    }
    const uId = Number(currentUser.id);

    // Cargar datos
    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const [resCompra, resArchivos, resSuplencias] = await Promise.all([
                axios.get(`${API_URL}/api/compras/${id}`, { headers: { Authorization: `Bearer ${token}` } }),
                axios.get(`${API_URL}/api/compras/${id}/archivos`, { headers: { Authorization: `Bearer ${token}` } }),
                axios.get(`${API_URL}/auth/${uId}/mis-suplencias-activas`, { headers: { Authorization: `Bearer ${token}` } })
            ]);

            const data = resCompra.data;
            const suplencias = resSuplencias.data || [];
            
            // Verificar Permisos
            const esSuplente = suplencias.some(s => s.id_usuario === data.id_solicitante);
            if (currentUser.rol !== 'ADMINISTRADOR' && uId !== data.id_solicitante && uId !== data.id_usuario_creador && !esSuplente) {
                Swal.fire('Acceso Denegado', 'Solo el solicitante original o su suplente pueden editar esta petición.', 'error');
                navigate('/dashboard');
                return;
            }

            // Rellenar estados
            setCp(data.cp || '861/862 TERMOSOLARES');
            setDepartamento(data.departamento || '');
            setIdSolicitante(data.id_solicitante);
            setNombreSolicitanteLabel(`${data.solicitante_nombre} ${data.solicitante_apellidos}`);
            setTipoSolicitud(data.tipo_solicitud || 'REPUESTOS');
            setJustificacion(data.justificacion || '');
            
            if (data.materiales && data.materiales.length > 0) {
                setMateriales(data.materiales.map(m => ({
                    articulo: m.articulo || '',
                    descripcion: m.descripcion || '',
                    cantidad: m.cantidad || '',
                    ot_referencia: m.ot_referencia || '',
                    planta_destino: m.planta_destino || ''
                })));
            } else {
                setMateriales([{ articulo: '', descripcion: '', cantidad: '', ot_referencia: '', planta_destino: '' }]);
            }

            setArchivosSubidos(resArchivos.data || []);
            setLoading(false);

        } catch (error) {
            console.error("Error cargando solicitud:", error);
            Swal.fire('Error', 'No se pudo cargar la solicitud.', 'error');
            navigate('/dashboard');
        }
    }, [id, token, navigate, uId, currentUser.rol]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    // Tabla de materiales
    const handleAddFila = () => {
        setMateriales([...materiales, { articulo: '', descripcion: '', cantidad: '', ot_referencia: '', planta_destino: '' }]);
    };

    const handleRemoveFila = (idx) => {
        if (materiales.length === 1) {
            return Swal.fire('Atención', 'La solicitud debe contener al menos un material.', 'warning');
        }
        setMateriales(materiales.filter((_, i) => i !== idx));
    };

    const handleMaterialChange = (idx, field, val) => {
        const nuevos = [...materiales];
        nuevos[idx][field] = val;
        setMateriales(nuevos);
    };

    // Gestión de Archivos Antiguos
    const handleDescargarArchivo = async (idArchivo, nombre, tipo) => {
        try {
            const res = await axios.get(`${API_URL}/api/compras/archivo/${idArchivo}`, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob'
            });
            const url = window.URL.createObjectURL(new Blob([res.data], { type: tipo }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nombre);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        } catch (error) {
            Swal.fire('Error', 'No se pudo descargar el archivo.', 'error');
        }
    };

    const handleEliminarArchivoServidor = async (idArchivo, nombre) => {
        const confirm = await Swal.fire({
            title: '¿Eliminar archivo?',
            text: `Se borrará "${nombre}" permanentemente de la nube.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d32f2f',
            confirmButtonText: 'Sí, borrar'
        });

        if (confirm.isConfirmed) {
            try {
                await axios.delete(`${API_URL}/api/compras/archivo/${idArchivo}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setArchivosSubidos(prev => prev.filter(a => a.id_archivo !== idArchivo));
                Swal.fire('Borrado', 'El archivo ha sido eliminado.', 'success');
            } catch (error) {
                Swal.fire('Error', 'No se pudo eliminar el archivo.', 'error');
            }
        }
    };

    // Envío del formulario
    const procesarGuardado = async () => {
        if (!departamento) return Swal.fire('Campo requerido', 'Selecciona el Taller o Departamento.', 'warning');

        const filasValidas = materiales.filter(m => m.descripcion.trim() !== '' && m.cantidad.trim() !== '');
        if (filasValidas.length === 0) return Swal.fire('Materiales requeridos', 'Debes especificar al menos un material con descripción y cantidad.', 'warning');

        if ((tipoSolicitud === 'REPUESTOS' || tipoSolicitud === 'HERRAMIENTA_ESPECIFICA') && !justificacion.trim()) {
            return Swal.fire('Justificación obligatoria', 'Para Repuestos o Herramientas Específicas es obligatorio indicar una justificación.', 'warning');
        }

        setGuardando(true);

        const payload = {
            cp,
            departamento,
            id_solicitante: idSolicitante, // Mantenemos el solicitante original
            tipo_solicitud: tipoSolicitud,
            justificacion: justificacion.trim(),
            materiales: filasValidas
        };

        try {
            await axios.put(`${API_URL}/api/compras/${id}`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            });

            // Subir nuevos archivos adjuntos si los hay
            if (archivosNuevos.length > 0) {
                for (const file of archivosNuevos) {
                    const formDataFile = new FormData();
                    formDataFile.append('file', file);
                    await axios.post(`${API_URL}/api/compras/${id}/subir-archivo`, formDataFile, {
                        headers: { 
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'multipart/form-data' 
                        }
                    });
                }
            }

            Swal.fire({
                title: '¡Cambios Guardados!',
                text: `La solicitud de compra #${id} ha sido actualizada.`,
                icon: 'success',
                confirmButtonColor: '#003366',
            }).then(() => {
                navigate(`/compras/${id}`);
            });

        } catch (error) {
            console.error("Error al guardar solicitud:", error);
            Swal.fire('Error', error.response?.data?.error || 'No se pudo actualizar la solicitud.', 'error');
        } finally {
            setGuardando(false);
        }
    };

    if (loading) return <div className="loading-container">Cargando datos de edición...</div>;

    return (
        <div className="container">
            <form onSubmit={(e) => { e.preventDefault(); procesarGuardado(); }}>
                <div className="top-header" style={{ borderLeftColor: '#003366' }}>
                    <div className="d-flex align-center">
                        <span className="ptw-label">EDITANDO SOLICITUD:</span>
                        <div className="ptw-badge" style={{ backgroundColor: '#003366' }}>
                            ✏️ COMPRAS #{id}
                        </div>
                    </div>
                    <div className="header-actions">
                        <button type="submit" disabled={guardando} className="btn-save" style={{ backgroundColor: '#003366' }}>
                            💾 Guardar y Volver
                        </button>
                        <button type="button" onClick={() => navigate(`/compras/${id}`)} className="btn-close">
                            Cancelar
                        </button>
                    </div>
                </div>

                <div className="main-card">
                    <div className="card-header-internal" style={{ color: '#003366' }}>
                        1. Datos de la Solicitud
                    </div>
                    <div className="row">
                        <div className="info-box flex-1">
                            <span className="info-label">CENTRO DE PRODUCCIÓN *</span>
                            <select 
                                required className="main-select" value={cp} 
                                onChange={e => {
                                    const nuevoCp = e.target.value;
                                    if (nuevoCp === '579' && currentUser.rol !== 'ADMINISTRADOR' && !(currentUser.rol === 'GESTOR' && ['SOLAR', 'EOLICO'].includes(currentUser.grupo))) {
                                        return Swal.fire('Acceso denegado', 'Solo Gestores SOLAR/EOLICO pueden usar 579.', 'error');
                                    }
                                    setCp(nuevoCp);
                                    setDepartamento('');
                                }}
                            >
                                <option value="861/862 TERMOSOLARES">861/862 TERMOSOLARES</option>
                                <option value="579">579</option>
                            </select>
                        </div>
                        <div className="info-box flex-1">
                            <span className="info-label">TALLER / DEPARTAMENTO *</span>
                            <select required className="main-select" value={departamento} onChange={e => setDepartamento(e.target.value)}>
                                <option value="">-- Seleccionar --</option>
                                {(cp === '579' ? DEPARTAMENTOS_579 : DEPARTAMENTOS_861).map(d => (
                                    <option key={d.valor} value={d.valor}>{d.label}</option>
                                ))}
                            </select>
                        </div>
                        <div className="info-box flex-2">
                            <span className="info-label">SOLICITANTE (Bloqueado)</span>
                            <input type="text" className="main-input" value={nombreSolicitanteLabel} readOnly style={{ backgroundColor: '#f0f4f8', color: '#666' }} />
                        </div>
                    </div>
                </div>

                <div className="main-card">
                    <div className="card-header-internal" style={{ color: '#003366' }}>2. Tipo de Solicitud</div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '15px' }}>
                        {TIPOS_SOLICITUD.map(t => (
                            <label key={t.id} className="hab-item" style={{ border: tipoSolicitud === t.id ? '2px solid #003366' : '1px solid #ddd', backgroundColor: tipoSolicitud === t.id ? '#e3f2fd' : '#fff' }}>
                                <input type="radio" name="tipoSolicitud" checked={tipoSolicitud === t.id} onChange={() => setTipoSolicitud(t.id)} />
                                <strong style={{ fontSize: '12px', color: '#003366' }}>{t.label}</strong>
                            </label>
                        ))}
                    </div>
                </div>

                <div className="main-card">
                    <div className="card-header-internal" style={{ color: '#003366' }}>3. Detalles del Material</div>
                    <table className="table">
                        <thead>
                            <tr className="table-header">
                                <th className="th" style={{ width: '15%' }}>Artículo</th>
                                <th className="th" style={{ width: '40%' }}>Descripción / Especificaciones *</th>
                                <th className="th" style={{ width: '15%' }}>Cantidad *</th>
                                <th className="th" style={{ width: '20%' }}>Nº OT</th>
                                <th className="th" style={{ width: '20%' }}>Planta / Destino</th>
                                <th className="th" style={{ width: '5%', textAlign: 'center' }}>Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {materiales.map((m, idx) => (
                                <tr key={idx}>
                                    <td className="td"><input type="text" className="borderless-input" placeholder="Ej: ART-1024" value={m.articulo} onChange={e => handleMaterialChange(idx, 'articulo', e.target.value)} /></td>
                                    <td className="td"><input type="text" className="borderless-input" placeholder="Obligatorio" value={m.descripcion} onChange={e => handleMaterialChange(idx, 'descripcion', e.target.value)} /></td>
                                    <td className="td"><input type="text" className="borderless-input" placeholder="Obligatorio" value={m.cantidad} onChange={e => handleMaterialChange(idx, 'cantidad', e.target.value)} /></td>
                                    <td className="td"><input type="text" className="borderless-input" placeholder="Ej: OT-10492" value={m.ot_referencia} onChange={e => handleMaterialChange(idx, 'ot_referencia', e.target.value)} /></td>
                                    <td className="td"><input type="text" className="borderless-input" placeholder="Ej: Aste 1A" value={m.planta_destino} onChange={e => handleMaterialChange(idx, 'planta_destino', e.target.value)} /></td>
                                    <td className="td text-center">
                                        <button type="button" onClick={() => handleRemoveFila(idx)} style={{ background: 'none', border: 'none', color: '#d32f2f', cursor: 'pointer', fontWeight: 'bold' }}>✖</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <button type="button" onClick={handleAddFila} className="add-btn" style={{ backgroundColor: '#003366' }}>➕ Añadir Línea</button>
                </div>

                <div className="main-card">
                    <div className="card-header-internal" style={{ color: '#003366' }}>4. Justificación de la Necesidad</div>
                    <textarea rows="3" className="main-textarea" value={justificacion} onChange={e => setJustificacion(e.target.value)} />
                </div>

                <div className="document-section">
                    <h3 className="section-title">📎 Archivos y Documentos Adjuntos</h3>
                    {archivosSubidos.length > 0 && (
                        <div className="document-list mb-20">
                            <strong className="text-subtitle">Archivos ya subidos:</strong>
                            {archivosSubidos.map(archivo => (
                                <div key={archivo.id_archivo} className="document-item">
                                    <div className="document-info">
                                        <span className="document-icon">🗎</span>
                                        <span>{archivo.nombre_archivo}</span>
                                    </div>
                                    <div className="document-actions">
                                        <button type="button" onClick={() => handleDescargarArchivo(archivo.id_archivo, archivo.nombre_archivo, archivo.tipo_archivo)} className="btn-download-file">⬇️ Descargar</button>
                                        <button type="button" onClick={() => handleEliminarArchivoServidor(archivo.id_archivo, archivo.nombre_archivo)} className="btn-delete-file">🗑️ Borrar</button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                    <div className="document-upload-zone">
                        <strong className="text-subtitle">Añadir nuevos documentos:</strong>
                        <input type="file" accept=".pdf,.xls,.xlsx,.doc,.docx,image/*" multiple onChange={(e) => {
                            const files = Array.from(e.target.files);
                            setArchivosNuevos(prev => [...prev, ...files]);
                        }} />
                    </div>
                    {archivosNuevos.length > 0 && (
                        <div className="document-list mt-10">
                            {archivosNuevos.map((file, index) => (
                                <div key={index} className="document-item document-item-pending">
                                    <div className="document-info">
                                        <span className="document-icon">⏳</span><span>{file.name}</span>
                                    </div>
                                    <button type="button" onClick={() => setArchivosNuevos(prev => prev.filter((_, i) => i !== index))} className="btn-delete-file">X Quitar</button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </form>
        </div>
    );
};

export default EditCompraScreen;